var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggested-link"},[_c('h4',{staticClass:"font-body-xs"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"font-body-xs"},[_vm._v(_vm._s(_vm.description))]),_c('span',{staticClass:"link"},[_vm._v(_vm._s(_vm.url))])])
}
var staticRenderFns = []

export { render, staticRenderFns }